module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon02-zh-hans-eef789e57f44ad7d1dd4912c52ae0877.png";